import { COLORS } from '../constants';

const TRANSPARENT_COLOR = {
    primary: 'transparent',
    secondary: 'transparent',
    text: '#2f2f2f'
};

export const getColor = color => {
    if (!color || color === 'transparent') {
        return TRANSPARENT_COLOR;
    }


    return COLORS[color] || TRANSPARENT_COLOR;
}

export const getGradient = color => {
    const { primary, secondary } = getColor(color);

    return `linear-gradient(180deg, ${primary} 0%, ${secondary} 100%)`;
}

export const getTextColor = color => {
    const { text } = getColor(color);

    return text;
}
